import { apiPaths } from 'app/services/api';
import React from 'react';
import CrudGridForm from '../../smart-kit/Form/CrudGridForm';

const fields = [
  { label: 'Name', key: 'name', validation: { required: true } },
  { label: 'Address', key: 'address', validation: { required: false } },
  { label: 'City', key: 'city', validation: { required: false } },
  { label: 'Email', key: 'email', validation: { required: false } },
  { label: 'Phone Number', key: 'phone_number', validation: { required: false } },
  { label: 'Website', key: 'website', validation: { required: false } }

  // {label: 'Type', key: 'type', type: 'select', items: [{value: 'govermental', label: 'Govermental'}, {value: 'private', label: 'Private'},
  // {value: 'semiprivate', label: 'Semiprivate'}, {value: 'knowledge_enterprise', label: 'Knowledge Enterprise'},], validation: {required: false}},

  // {label: 'Industry', key: 'industry', validation: {required: false}},
  // {isTab: true, tabs: ['Package Info', 'Store Sellers']},
  // {label: 'Requested Package Count', key: 'requested_package_count', tab: 0, type: 'number', validation: {required: false}},
  // {label: 'Pickedup Package Name', key: 'pickedup_package_name', tab: 0, validation: {required: false}},

  // {tab: 1, label: 'Account Manager Name', key: 'account_manager_name'},
  // {tab: 1, label: 'Account Manager Last Name', key: 'account_manager_last_name'},
  // {tab: 1, label: 'Account Manager Mobile', key: 'account_manager_mobile_number'},

  // {tab: 1, label: 'HR Name', key: 'hr_name'},
  // {tab: 1, label: 'HR Last Name', key: 'hr_last_name'},
  // {tab: 1, label: 'HR Mobile', key: 'hr_mobile_number'},
];
const InsuranceForm = () => {
  return (
    <CrudGridForm
      path={apiPaths.INSURANCES}
      name="Insurance"
      entityName={'insurances'}
      fields={fields}
    />
  );
};

export default InsuranceForm;
